var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border rounded-lg border-grey-300"},[(_vm.title)?_c('CardHeader',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"icon":_vm.icon,"accentColor":_vm.accentColor}}):_vm._e(),(_vm.$slots.default)?_c('div',{staticClass:"rounded-lg",class:{
      'flex flex-col items-center': _vm.centerContent,
    }},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }